import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Form,
  Card,
  Space,
  DatePicker,
  Select,
  message,
  Image,
  Spin,
  Radio
} from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
// import moment from 'moment';
import LocalStorage from 'utilities/localStorage';
import Layout from '@/common/Layout';
import truck from '../../images/truck-delivery-done.gif';
// import { getAllMaterialslist } from '@/features/stockCard/redux/slice';
const { RangePicker } = DatePicker;
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { getAllMaterialslist } from '@/features/stockCard/redux/slice';
import { getPoNumbers } from '../../redux/slice';

const StockReportPage = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { allMaterials } = useSelector((state) => state.stocks);
  const [truckShow, setTruckShow] = useState(false);
  const [dateRange, setDateRange] = useState([moment(), moment()]);
  const [futerdate, setFuterdate] = useState(true);
  const [search, setSearch] = useState('');
  const [materialId, setMaterialId] = useState('');
  const [type, setType] = useState('');
  const [subType, setSubType] = useState('');
  const [poNumbers, setPoNumbers] = useState([]);
  // const [code, setCode] = useState('');

  useEffect(() => {
    handleGetAllMaterialsList();
    handleGetAllPONumbers();
  }, [search, subType]);

  const handleGetAllMaterialsList = () => {
    let payload = { search };
    dispatch(getAllMaterialslist(payload));
  };

  const handleGetAllPONumbers = () => {
    let payload = { type: subType, search };
    dispatch(getPoNumbers(payload)).then((res) => {
      if (res?.payload?.success) {
        setPoNumbers(res?.payload?.data);
      }
    });
  };
  const user = LocalStorage.getItem('Gravity_user');
  const onFinish = (values) => {
    const fromDate =
      subType === 'till_date'
        ? '2023-04-01'
        : values.fromDate
        ? `${moment(values.fromDate[0]._d).format('YYYY-MM-DD')}`
        : '';
    const toDate =
      subType === 'till_date'
        ? moment().format('YYYY-MM-DD')
        : values.fromDate
        ? `${moment(values.fromDate[1]._d).format('YYYY-MM-DD')}`
        : '';
    const asOfDate = values.asOfDate
      ? `${moment(values.asOfDate._d).format('YYYY-MM-DD')}`
      : '';

    setTruckShow(true);
    const authToken = user?.token;

    const pdfReports = [
      // 'invoice_tracker',
      'approved_material_status',
      'disqualified_material_status',
      'blocked_material_status',
      'provisional_approved_material_status',
      // 'dispensing_details_report',
      // 'receipt_details_report',
      'location_details_report',
      'hold_time_report',
      'ratification_log'
    ];

    const isPDF = pdfReports.includes(values.report);

    let url = '';
    if (isPDF) {
      url =
        subType === 'date_range' || subType === 'till_date'
          ? `${process.env.REACT_APP_API_URL}/other-reports?report_type=${values.report}&from_date=${fromDate}&to_date=${toDate}`
          : values.report === 'location_details_report' ||
            values.report === 'receipt_details_report' ||
            values.report === 'hold_time_report' ||
            values.report === 'ratification_log'
          ? `${process.env.REACT_APP_API_URL}/other-reports?report_type=${values.report}&from_date=${fromDate}&to_date=${toDate}`
          : `${process.env.REACT_APP_API_URL}/other-reports?report_type=${values.report}&type=${subType}&search=${materialId}`;
    } else {
      url =
        values.report === 'invoice_tracker'
          ? `${process.env.REACT_APP_API_URL}/other-reports?report_type=${values.report}&type=${subType}&search=${materialId}`
          : values.report === 'closing_stock_report'
          ? `${process.env.REACT_APP_API_URL}/other-reports?report_type=${values.report}&as_of_date=${asOfDate}`
          : `${process.env.REACT_APP_API_URL}/other-reports?report_type=${values.report}&from_date=${fromDate}&to_date=${toDate}&material_id=${materialId}`;
    }

    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    })
      .then((response) => (isPDF ? response.json() : response.blob()))
      .then((data) => {
        if (isPDF) {
          if (data?.data) {
            // window.open(data.data, '_blank');
            window.open(
              `${process.env.REACT_APP_STORAGE_URL}${data.data
                .split('/')
                .pop()}`,
              '_blank'
            );
            message.success('PDF Report opened successfully');
          } else {
            message.error('Failed to get PDF URL');
          }
        } else {
          const blobUrl = window.URL.createObjectURL(data);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.setAttribute('download', `${values.report}.csv`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          message.success('CSV downloaded successfully');
        }

        form.resetFields();
        setTruckShow(false);
      })
      .catch((error) => {
        console.error('Error fetching report:', error);
        message.error('Failed to fetch report');
        setTruckShow(false);
      });
  };

  const handleChange = (e) => {
    setType(e);
    if (e === 'retest_material_report' || e === 'expiry_material_report') {
      setFuterdate(false);
    } else {
      setFuterdate(true);
    }
  };

  const onSearch = (value) => {
    setSearch(value);
  };

  const onChange = (value) => {
    setMaterialId(value);
  };

  const onChangeType = (e) => {
    console.log(e);
    setSubType(e.target.value);
  };

  return (
    <Layout sider={false}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Card title={'DOWNLOAD OTHER REPORTS'} className={styles.CustomPanel}>
          <Row gutter={24}>
            <Col xs={24} xl={6} span={12} md={24} sm={24}>
              <FormItem
                label="Other reports"
                name="report"
                rules={[
                  {
                    required: true,
                    message: 'Select Statement'
                  }
                ]}
                className={styles.customLable}
              >
                <Select
                  placeholder="Please select report"
                  onChange={(e) => handleChange(e)}
                >
                  {user?.user?.role === 'finance_user' && (
                    <>
                      <option value="material_receipt_report">
                        Material receipt report
                      </option>
                      <option value="closing_stock_report">
                        Closing stock report
                      </option>
                      <option value="material_issue_report">
                        Material issue report
                      </option>
                    </>
                  )}
                  <option value="stock_reconsiliation">
                    Stock reconciliation
                  </option>
                  <option value="wastage_material_transactions_stock">
                    Wastage material
                  </option>
                  <option value="retest_material_report">
                    Retest material
                  </option>
                  <option value="expiry_material_report">
                    Expiry material
                  </option>
                  <option value="damage_report">Damage report</option>
                  <option value="non_moving_type">Non moving stock</option>
                  <option value="material_stock_report">
                    Material stock report
                  </option>
                  <option value="invoice_tracker">
                    Invoice tracker report
                  </option>
                  <option value="approved_material_status">
                    Approved vendor report
                  </option>
                  <option value="disqualified_material_status">
                    Disqualified vendor report
                  </option>
                  <option value="blocked_material_status">
                    Blocked vendor report
                  </option>
                  <option value="provisional_approved_material_status">
                    Provisionally approved
                  </option>
                  <option value="dispensing_details_report">
                    Dispensing details report
                  </option>
                  <option value="receipt_details_report">
                    Receipt details report
                  </option>
                  <option value="product_line_clearance_report">
                    Product line clearance report
                  </option>
                  <option value="location_details_report">
                    Location details report
                  </option>
                  <option value="hold_time_report">Hold time report</option>
                  <option value="closing_stock_report">
                    Closing stock report
                  </option>
                  {/* <option value="ratification_log">Ratification report</option> */}
                </Select>
              </FormItem>
            </Col>
            {
              <>
                {type === 'invoice_tracker' && (
                  <Col xs={24} xl={6} span={6} md={24} sm={24}>
                    <FormItem
                      label="Select Type"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Select date'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Radio.Group onChange={onChangeType}>
                        <Radio value="po_num">PO no.</Radio>
                        <Radio value="invoice_num">Invoice no.</Radio>
                        <Radio value="date_range">Date</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                )}
                {(type === 'approved_material_status' ||
                  type === 'disqualified_material_status' ||
                  type === 'blocked_material_status' ||
                  type === 'provisional_approved_material_status') && (
                  <Col xs={24} xl={6} span={6} md={24} sm={24}>
                    <FormItem
                      label="Select Type"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Select date'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Radio.Group onChange={onChangeType}>
                        <Radio value="date_range">Date range</Radio>

                        <Radio value="till_date">Till date</Radio>
                      </Radio.Group>
                    </FormItem>
                  </Col>
                )}
                {subType === 'po_num' ? (
                  <Col xs={24} xl={12} span={12} md={24} sm={24}>
                    <FormItem
                      label="Enter PO Number"
                      name="po_no"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Select date'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        showSearch
                        placeholder="Select a PO number"
                        optionFilterProp="children"
                        onChange={(e) => onChange(e, 'id')}
                        onSearch={onSearch}
                      >
                        {poNumbers ? (
                          poNumbers?.map((item, index) => {
                            return (
                              <option value={item.po_no} key={index}>
                                {item.po_no}
                              </option>
                            );
                          })
                        ) : (
                          <Spin />
                        )}
                      </Select>
                    </FormItem>
                  </Col>
                ) : subType === 'invoice_num' ? (
                  <Col xs={24} xl={12} span={12} md={24} sm={24}>
                    <FormItem
                      label="Enter Invoice Number"
                      name="inv_no"
                      rules={[
                        {
                          required: true,
                          message: 'Enter Select date'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        showSearch
                        placeholder="Select a Invoice number"
                        optionFilterProp="children"
                        onChange={(e) => onChange(e, 'id')}
                        onSearch={onSearch}
                      >
                        {poNumbers ? (
                          poNumbers?.map((item, index) => {
                            return (
                              <option value={item.invoice_no} key={index}>
                                {item.invoice_no}
                              </option>
                            );
                          })
                        ) : (
                          <Spin />
                        )}
                      </Select>
                    </FormItem>
                  </Col>
                ) : type === 'closing_stock_report' ? (
                  <Col xs={24} xl={12} span={12} md={24} sm={24}>
                    <FormItem
                      label="Select date"
                      name="asOfDate"
                      rules={[
                        {
                          required: true,
                          message: 'Select date'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <DatePicker
                        format={'DD-MM-YYYY'}
                        disabledDate={(current) =>
                          current && current.valueOf() > Date.now()
                        }
                        style={{ width: '100%' }}
                      />
                    </FormItem>
                  </Col>
                ) : (
                  (subType === 'date_range' ||
                    type === 'dispensing_details_report' ||
                    type === 'receipt_details_report' ||
                    type === 'location_details_report' ||
                    type === 'hold_time_report' ||
                    type === 'material_receipt_report' ||
                    type === 'material_issue_report' ||
                    type === 'ratification_log' ||
                    type === 'product_line_clearance_report') && (
                    <Col xs={24} xl={12} span={12} md={24} sm={24}>
                      <FormItem
                        label="Select start and end date"
                        name="fromDate"
                        rules={[
                          {
                            required: true,
                            message: 'Enter Select date'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <RangePicker
                          format={'DD-MM-YYYY'}
                          onChange={(x) => {
                            setDateRange(x);
                          }}
                          disabledDate={
                            futerdate
                              ? (current) => {
                                  return (
                                    current && current.valueOf() > Date.now()
                                  );
                                }
                              : false
                          }
                          value={dateRange}
                          // separator={'-'}
                          style={{ width: '100%' }}
                        />
                      </FormItem>
                    </Col>
                  )
                )}
                {type !== 'invoice_tracker' ||
                  type !== 'approved_material_status' ||
                  (type !== 'disqualified_material_status' && (
                    <Col xs={24} xl={12} span={12} md={24} sm={24}>
                      <FormItem
                        label="Select start and end date"
                        name="fromDate"
                        rules={[
                          {
                            required: true,
                            message: 'Enter Select date'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <RangePicker
                          format={'DD-MM-YYYY'}
                          onChange={(x) => {
                            setDateRange(x);
                          }}
                          disabledDate={
                            futerdate
                              ? (current) => {
                                  return (
                                    current && current.valueOf() > Date.now()
                                  );
                                }
                              : false
                          }
                          value={dateRange}
                          // separator={'-'}
                          style={{ width: '100%' }}
                        />
                      </FormItem>
                    </Col>
                  ))}
                {type === 'material_stock_report' && (
                  <Col xs={24} xl={6} span={6} md={24} sm={24}>
                    <FormItem
                      label="Material Code"
                      name="material_id"
                      rules={[
                        {
                          required: true,
                          message: 'Select Material Code'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        showSearch
                        placeholder="Select a material code"
                        optionFilterProp="children"
                        onChange={(e) => onChange(e, 'id')}
                        onSearch={onSearch}
                      >
                        {allMaterials ? (
                          allMaterials?.map((item, index) => {
                            return (
                              <option value={item.id} key={index}>
                                {item.code}
                              </option>
                            );
                          })
                        ) : (
                          <Spin />
                        )}
                      </Select>
                    </FormItem>
                  </Col>
                )}
              </>
            }
          </Row>
        </Card>
        <br />
        <FormItem className="text-center">
          {truckShow ? (
            <Image
              src={truck}
              preview={false}
              style={{ width: '100px !important', height: '100px' }}
            />
          ) : (
            <Space>
              <CustomButton
                className={styles.inwardButton}
                htmlType="submit"
                type="primary"
              >
                Download
              </CustomButton>
              <CustomButton
                className={styles.inwardButton}
                type="primary"
                ghost
                onClick={() => history.back()}
              >
                Back
              </CustomButton>
            </Space>
          )}
        </FormItem>
      </Form>
    </Layout>
  );
};
export default StockReportPage;
